import React from "react";
import upperCase from "lodash/upperCase";
import styles from "./contact-image-component.module.scss";
import classnames from "classnames";
import { AsyncImage } from "../AsyncImage";

export const ContactImageComponent: React.FC<{
  img: string | undefined;
  isGroup?: boolean;
  name?: string;
  size?: "small" | "default";
  className?: string;
}> = React.memo(({ img, isGroup, name, size = "default", className }) => {
  if (!img) {
    if (isGroup) {
      return (
        <div className={classnames(styles.noImage, styles[size], className)}>
          {name ? (
            <span className={styles.noImageName}>{upperCase(name[0])}</span>
          ) : (
            <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M33.75 11.0964C33.75 9.41256 33.05 7.88847 31.92 6.78624C30.7888 5.6828 29.2263 5 27.5 5C25.7738 5 24.2112 5.6828 23.08 6.78624C21.95 7.88847 21.25 9.41256 21.25 11.0964C21.25 12.7802 21.95 14.3043 23.08 15.4065C24.2112 16.51 25.7738 17.1928 27.5 17.1928C29.2263 17.1928 30.7888 16.51 31.92 15.4065C33.05 14.3043 33.75 12.7802 33.75 11.0964ZM20 24.5614C20 25.7807 22.8125 27 27.5 27C31.8975 27 35 25.7807 35 24.5614C35 22.1229 32.0575 19.6843 27.5 19.6843C22.8125 19.6843 20 22.1229 20 24.5614Z"
                fill="white"
              />
              <path
                d="M20.3667 9.75904C20.3667 7.34754 19.3676 5.167 17.7636 3.59493C16.1585 2.02173 13.9426 1.05 11.5 1.05C9.05739 1.05 6.84153 2.02173 5.23637 3.59493C3.63236 5.167 2.63333 7.34754 2.63333 9.75904C2.63333 12.1705 3.63236 14.3511 5.23637 15.9231C6.84153 17.4963 9.05739 18.4681 11.5 18.4681C13.9426 18.4681 16.1585 17.4963 17.7636 15.9231C19.3676 14.3511 20.3667 12.1705 20.3667 9.75904ZM1.05 26.8964C1.05 27.6715 1.49467 28.3001 2.0332 28.759C2.57871 29.2239 3.32568 29.6118 4.20451 29.925C5.96982 30.5541 8.45997 30.95 11.5 30.95C14.363 30.95 16.8478 30.5524 18.65 29.9277C19.5463 29.617 20.3213 29.2339 20.8917 28.7783C21.4435 28.3378 21.95 27.7059 21.95 26.8964C21.95 24.9487 20.7874 23.1373 18.9616 21.8521C17.1248 20.5591 14.5515 19.7392 11.5 19.7392C8.371 19.7392 5.79382 20.5568 3.97203 21.8553C2.15605 23.1497 1.05 24.9635 1.05 26.8964Z"
                fill="white"
                stroke="#3E77B2"
                strokeWidth="1.9"
              />
            </svg>
          )}
        </div>
      );
    }
    return (
      <div className={classnames(styles.noImage, styles[size], className)}>
        {name ? (
          <span className={styles.noImageName}>{upperCase(name[0])}</span>
        ) : (
          <svg width="24" height="36" viewBox="0 0 24 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.5833 10.25C21.5833 7.60307 20.51 5.20724 18.7773 3.47457C17.0428 1.73999 14.6469 0.666656 12 0.666656C9.35308 0.666656 6.95725 1.73999 5.22267 3.47457C3.49 5.20724 2.41667 7.60307 2.41667 10.25C2.41667 12.8969 3.49 15.2927 5.22267 17.0254C6.95725 18.76 9.35308 19.8333 12 19.8333C14.6469 19.8333 17.0428 18.76 18.7773 17.0254C20.51 15.2927 21.5833 12.8969 21.5833 10.25ZM0.5 31.4167C0.5 33.3333 4.8125 35.25 12 35.25C18.7428 35.25 23.5 33.3333 23.5 31.4167C23.5 27.5833 18.9882 23.75 12 23.75C4.8125 23.75 0.5 27.5833 0.5 31.4167Z"
              fill="white"
            />
          </svg>
        )}
      </div>
    );
  }
  return (
    <div className={classnames(styles.image, styles[size], className)}>
      <AsyncImage src={img} alt="person-image" />
    </div>
  );
});
